import { makeStyles } from '@material-ui/core';

export default makeStyles(theme => ({
  title: {
    marginBottom: theme.spacing(2),
  },
}));
